import StoreEnum from 'lib/storeLocales/enums/StoreEnum';
import CurrencyEnum from 'lib/storeLocales/enums/CurrencyEnum';
import config from 'lib/storeLocales/config';

const getCurrency = (store: StoreEnum): CurrencyEnum => CurrencyEnum[config.storeCurrencies[store]];

export default getCurrency;
